<template>
  <div id="activities">
    <!-- 活動列表 -->
    <div
      class="wrap"
      v-infinite-scroll="nextPage"
      infinite-scroll-disabled="busy"
      infinite-scroll-throttle-delay="50"
      infinite-scroll-distance="100"
    >
      <section class="activities container">
        <h2 class="title text-secondary">活動列表</h2>
        <div
          class="row d-flex"
          v-masonry
          transition-duration="0"
          item-selector=".item"
          column-width=".item"
          stagger="0.03s"
        >
          <div
            v-masonry-tile
            class="col-md-6 col-12 mt-30 item"
            v-for="(item, index) in activities"
            :key="index"
            :ref="item.no"
          >
            <ContentBox
              :type="3"
              :id="item.id"
              :title="item.title"
              :brief="item.brief"
              :time="item.publish_at"
              :image="item.media.data"
              :video="item.youtube"
              :path="item.no"
            />
          </div>
        </div>
      </section>
      <div class="d-flex align-items-center justify-content-center" v-if="total_page!==page">
        <img src="/loading.svg" alt="loading" />
      </div>
    </div>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';
import ContentBox from '@/components/content-box.vue';

export default {
  name: 'activities',
  metaInfo: {
    title: ' - 活動紀錄',
  },
  data() {
    return {
      activities: [],
      pagination: [],
      page: 1,
      busy: false,
    };
  },
  components: {
    ContentBox,
  },
  computed: {
    total_page() {
      return this.pagination.total_pages;
    },
  },
  methods: {
    getActivities() {
      const url = '/article';
      const params = {
        search: 10,
        searchFields: 'category_id',
        sortedBy: 'desc',
        limit: 4,
        page: this.page,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.activities = [...this.activities, ...response.data.data];
          this.pagination = response.data.meta.pagination;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    nextPage() {
      if (this.total_page > this.page) {
        this.busy = true;
        setTimeout(() => {
          this.page = this.page + 1;
          this.busy = false;
        }, 1000);
      } else {
        this.busy = false;
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getActivities();
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target][0].scrollIntoView();
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
  watch: {
    page(value) {
      if (value) {
        this.getActivities();
      }
    },
    $route(to, from) {
      if (to.name || from.name) {
        this.page = 1;
        this.activities = [];
        this.getActivities();
      }
    },
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/all.scss';

#activities {
  .wrap {
    position: relative;
    background-color: lighten($sub-primary-white, 2.5%);
    @media (min-width: 768px) {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: url('~@/assets/images/bg-circle-left.svg'),
          url('~@/assets/images/bg-circle-right.svg');
        background-size: 170px auto, 170px auto;
        background-repeat: repeat-y, repeat-y;
        background-position: left top, right top;
      }
    }
  }
  .title {
    background: rgba(255, 255, 255, 0.8);
  }
  section:not(.hooper) {
    min-height: 450px;
    padding-top: 40px;
    padding-bottom: 80px;
    a {
      color: #000000;
      text-decoration: none;
    }
    .section-title {
      color: $secondary;
      position: relative;
      z-index: 1;
      &::before {
        position: absolute;
        content: '';
        height: 5px;
        background-color: $primary;
        opacity: 0.3;
        right: 0;
        left: 0;
        top: 12px;
        z-index: -1;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
